import React from 'react';
import { RadioGroup } from '@99designs/emu';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import { RadioChoiceFieldFragment } from './RadioChoiceField.generated';
import RadioListGrid from './RadioListGrid';

export interface PriceRange {
    rangeLow: number;
    rangeHigh?: number;
    currency: string;
}

export interface RadioOption {
    name: string;
    value: string;
    label: string;
    subtext?: string;
    purchasePrice?: string | PriceRange;
}

function createPriceRange(price: number[], currency: string): PriceRange {
    const [rangeLow, rangeHigh] = price;

    return {
        rangeLow,
        rangeHigh,
        currency,
    };
}

export type Props = RadioChoiceFieldFragment;

export function Edit({ label, tooltip, id, options, required, subtext }: Props) {
    const form = useForm();
    const { onChange } = form.attach(id, true);
    const isRadioListGrid =
        options && options.filter((option) => option.price).length === options.length;

    return isRadioListGrid ? (
        <Field
            form={form}
            name={id}
            title={''}
            message={''}
            required={required ?? false}
            render={() => (
                <RadioListGrid
                    label={label}
                    subtext={subtext ?? ''}
                    options={options.map((option) => {
                        return {
                            name: option.name ?? '',
                            value: option.value,
                            label: option.label,
                            subtext: option.subtext ?? '',
                            purchasePrice: option.price
                                ? createPriceRange(
                                      option.price as number[],
                                      option.currency as string
                                  )
                                : '',
                        };
                    })}
                    selectedValue={form.get(id)}
                    onChange={onChange}
                />
            )}
        />
    ) : (
        <Field
            form={form}
            name={id}
            title={label}
            required={required ?? false}
            tooltip={tooltip ? tooltip : undefined}
            render={() => (
                <RadioGroup
                    name={id}
                    id={id}
                    label={''}
                    value={form.get(id)}
                    onChange={(e) => onChange(e.target.value)}
                    options={options.map((option) => ({
                        label: option.label,
                        value: option.value,
                    }))}
                />
            )}
        />
    );
}

export function View({ options, choiceValue }: Props) {
    const option = options.find((o) => o.value === choiceValue);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{option?.label}</>;
}

export function HasValue({ choiceValue }: Props): boolean {
    return choiceValue !== '';
}

export function getValue({ choiceValue }: Props) {
    return choiceValue;
}
